import {
	Directive,
	EventEmitter,
	Injector,
	Input,
	Output,
} from '@angular/core';

import {
	get,
	intersection,
	invoke,
	keys,
	uniqueId,
} from 'lodash';

import {
	ControlValueAccessor,
	NgModel,
} from '@angular/forms';

import { CommonBaseComponent } from '../../components/base.component';
import { ICommonValidationComponentCustomErrors } from './validation/validation.component';

declare type TCommonControlValidationMode = 'blur' | 'submit';

@Directive()
export class CommonControlComponent extends CommonBaseComponent implements ControlValueAccessor {
	@Input() model: any;
	@Output() modelChange = new EventEmitter<any>();

	@Input() isDisabled: boolean;
	@Input() isReadonly: boolean;
	@Input() ctrlClasses: string;
	@Input() name: string;
	@Input() customErrors: ICommonValidationComponentCustomErrors;

	@Output() changeEvent = new EventEmitter<any>();

	ngModelControl: NgModel;
	id = '';
	isFocused = false;
	isHovered = false;

	protected idKey = 'control_';

	private validationMode: TCommonControlValidationMode;

	constructor (protected injector: Injector) {
		super(injector);
	}

	writeValue (value: any): void {
		this.model = value;
		this.runUpdate();
	}

	registerOnChange (fn: any): void {
		this.onChangeForValueAccessor = fn;
	}

	registerOnTouched (fn: any): void {
		this.onTouchedForValueAccessor = fn;
	}

	ngOnInit () {
		super.ngOnInit();

		this.ngModelControl = this.injector.get(NgModel);

		this.id = uniqueId(this.idKey);

		if (get(this.ngModelControl, 'formDirective')) {
			if (this.ngModelControl.formDirective) {
				this.subscribe(this.ngModelControl.formDirective.ngSubmit, () => {
					this.changeDetector.detectChanges();
				});
			}

			this.subscribe(this.ngModelControl.control.statusChanges, () => {
				this.changeDetector.detectChanges();
			});

			// Если на форме есть editFormSubmitWidget то подсветка ошибок будет происходить после первого сабмита формы
			// Если editFormSubmitWidget нет — после blur любого элемета формы
			setTimeout(() => {
				const controls = keys(this.ngModelControl.formDirective.controls);
				const submitControls = ['editFormSubmitWidget', 'submitButton'];

				this.validationMode = intersection(controls, submitControls).length > 0 ? 'submit' : 'blur';
			});
		}
	}

	isValid () {
		const submitted = get(this, 'ngModelControl.formDirective.submitted');

		if (submitted && !this.isDisabled) {
			return this.ngModelControl.valid;
		} else {
			return true;
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onMouseEnterHandler (event?: Event): void {
		this.isHovered = true;
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onMouseLeaveHandler (event?: Event): void {
		this.isHovered = false;
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onFocusHandler (event?: Event): void {
		this.isFocused = true;
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onBlurHandler (event?: Event): void {
		this.isFocused = false;

		if (this.onTouchedForValueAccessor) {
			this.onTouchedForValueAccessor();
		}

		this.formSubmitAfterBlur();
	}

	updateValueAndValidity (): void {
		invoke(this, 'ngModelControl.control.updateValueAndValidity');
	}

	protected formSubmitAfterBlur (): void {
		if (this.validationMode === 'blur' && !this.ngModelControl.formDirective.submitted && !this.ngModelControl.formDirective.valid) {
			this.ngModelControl.formDirective.onSubmit(null);
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	protected onChangeForValueAccessor (value: any) { /**/ }

	protected onTouchedForValueAccessor () { /**/ }

	protected emitOnChange (value: any) {
		this.onChangeForValueAccessor(value);
		this.changeEvent.emit(value);
	}
}
